import { settingsConstants } from '../constants/settings.constants';
import settingsService from '../services/settings.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const settingsActions = {  
  update,  
  fetch ,
  fetchGlobal,
  updateGlobal,
  updateLicense,
  syncAhgoraUsers,
  syncAhgoraClock,
  syncApDataUsers,
  syncApDataClock,
  syncSinergyUsers,
  syncSinergyClock,
  syncTivitUsers,
  syncTivitClock,
  syncBemUsers,
  syncBemClock,
  syncFolhaCertaUsers,
  syncFolhaCertaClock,
  syncSeniorUsers,
  testForPontoConnection,
  syncForPontoClock,
  syncForPontoUsers,
  syncPontoTelUsers,
  syncPontoTelClock,
  testDatabaseConnection,
  syncDatabaseUsers,
  syncDatabaseClock,
  syncNorberUsers,
  syncAdpUsers,
  syncAdpClock,
  syncAccounts,
  testAzureAdAuth,
  createAzureAdPolicyAndGroup,  
  syncAzureAdUsers,
  expireRequests,
  removeExpired,
  fetchWebhooks,
  createWebhook,
  updateWebhook,
  deleteWebhook,
  getWebhook,
  uploadFile,
};

function updateGlobal (obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const globalSettings = await settingsService.updateGlobal(obj);
      dispatch(success(globalSettings));
      dispatch(alertActions.success("Configurações salvas"));
      history.push('/global-settings');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: settingsConstants.GLOBAL_UPDATE_REQUEST } }
  function success(globalSettings) { return { type: settingsConstants.GLOBAL_UPDATE_SUCCESS, globalSettings } }
  function failure(error) { return { type: settingsConstants.GLOBAL_UPDATE_FAILURE, error } }
}

function update (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const settingsServer = await settingsService.update(id, obj);
      dispatch(success(settingsServer));
      dispatch(alertActions.success("Configurações salvas"));
      history.push('/settings');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: settingsConstants.UPDATE_REQUEST } }
  function success(settings) { return { type: settingsConstants.UPDATE_SUCCESS, settings } }
  function failure(error) { return { type: settingsConstants.UPDATE_FAILURE, error } }
}

function uploadFile(file) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await settingsService.uploadFile(file);
      dispatch(success(result));
      dispatch(alertActions.success("Arquivo Enviado"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: settingsConstants.UPLOAD_REQUEST } }
  function success(result) { return { type: settingsConstants.UPLOAD_SUCCESS, result } }
  function failure(error) { return { type: settingsConstants.UPLOAD_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const settingsServers = await settingsService.fetch(params);

      dispatch(success(settingsServers));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
      history.push("/")
    }
  };

  function request() { return { type: settingsConstants.FETCH_REQUEST } }
  function success(settings) { return { type: settingsConstants.FETCH_SUCCESS, settings } }
  function failure(error) { return { type: settingsConstants.FETCH_FAILURE, error } }
}

function createWebhook(obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const webhook = await settingsService.createWebhook(obj);
      dispatch(success(webhook));
      dispatch(alertActions.success("Webhook salvo"));
      history.push('/settings/webhooks');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: settingsConstants.WEBHOOK_CREATE_REQUEST } }
  function success(settings) { return { type: settingsConstants.WEBHOOK_CREATE_SUCCESS, settings } }
  function failure(error) { return { type: settingsConstants.WEBHOOK_CREATE_FAILURE, error } }
}

function getWebhook(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const webhook = await settingsService.getWebhook(id);
      dispatch(success(webhook));            
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: settingsConstants.WEBHOOK_GET_REQUEST } }
  function success(webhook) { return { type: settingsConstants.WEBHOOK_GET_SUCCESS, webhook } }
  function failure(error) { return { type: settingsConstants.WEBHOOK_GET_FAILURE, error } }
}

function updateWebhook(id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const webhook = await settingsService.updateWebhook(id, obj);
      dispatch(success(webhook));
      dispatch(alertActions.success("Webhook salvo"));
      history.push('/settings/webhooks');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: settingsConstants.UPDATE_REQUEST } }
  function success(webhook) { return { type: settingsConstants.UPDATE_SUCCESS, webhook } }
  function failure(error) { return { type: settingsConstants.UPDATE_FAILURE, error } }
}

function deleteWebhook(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const webhook = await settingsService.deleteWebhook(id);
      dispatch(success(webhook));
      dispatch(alertActions.success("Webhook removido"));
      history.push('/settings/webhooks');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: settingsConstants.UPDATE_REQUEST } }
  function success(webhook) { return { type: settingsConstants.UPDATE_SUCCESS, webhook } }
  function failure(error) { return { type: settingsConstants.UPDATE_FAILURE, error } }
}

function fetchWebhooks(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const webhooks = await settingsService.fetchWebhooks(params);      
      dispatch(success(webhooks));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
      history.push("/")
    }
  };

  function request() { return { type: settingsConstants.WEBHOOK_FETCH_REQUEST } }
  function success(webhooks) { return { type: settingsConstants.WEBHOOK_FETCH_SUCCESS, webhooks } }
  function failure(error) { return { type: settingsConstants.WEBHOOK_FETCH_FAILURE, error } }
}

function fetchGlobal(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const globalSettings = await settingsService.fetchGlobal(params);
      dispatch(success(globalSettings));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.GLOBAL_FETCH_REQUEST } }
  function success(globalSettings) { return { type: settingsConstants.GLOBAL_FETCH_SUCCESS, globalSettings } }
  function failure(error) { return { type: settingsConstants.GLOBAL_FETCH_FAILURE, error } }
}

function syncAhgoraUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const ahgoraUsers = await settingsService.syncAhgoraUsers(params);

      dispatch(success(ahgoraUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'ahgoraUsers' } }
  function success(ahgoraUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, ahgoraUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncPontoTelUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const pontoTelUsers = await settingsService.syncPontoTelUsers(params);

      dispatch(success(pontoTelUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'pontoTelUsers' } }
  function success(pontoTelUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, pontoTelUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncApDataUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const apDataUsers = await settingsService.syncApDataUsers(params);

      dispatch(success(apDataUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'apDataUsers' } }
  function success(apDataUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, apDataUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncSinergyUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const sinergyUsers = await settingsService.syncSinergyUsers(params);

      dispatch(success(sinergyUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'sinergyUsers' } }
  function success(sinergyUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, sinergyUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncTivitUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const ahgoraUsers = await settingsService.syncTivitUsers(params);

      dispatch(success(ahgoraUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'tivitUsers' } }
  function success(ahgoraUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, ahgoraUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncBemUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const bemUsers = await settingsService.syncBemUsers(params);

      dispatch(success(bemUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'bemUsers' } }
  function success(bemUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, bemUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncNorberUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const norberUsers = await settingsService.syncNorberUsers(params);

      dispatch(success(norberUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'norberUsers' } }
  function success(norberUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, norberUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncAdpUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const adpUsers = await settingsService.syncAdpUsers(params);

      dispatch(success(adpUsers));
      dispatch(alertActions.success('Sincronização iniciada. Verifique logs de integração'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'adpUsers' } }
  function success(adpUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, adpUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncAdpClock(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const adpUsers = await settingsService.syncAdpClock(params);

      dispatch(success(adpUsers));
      dispatch(alertActions.success('Sincronização iniciada. Verifique logs de integração'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'adpClock' } }
  function success(adpClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, adpClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncFolhaCertaUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const folhaCertaUsers = await settingsService.syncFolhaCertaUsers(params);

      dispatch(success(folhaCertaUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'folhaCertaUsers' } }
  function success(folhaCertaUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, folhaCertaUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncFolhaCertaClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const folhaCertaClock = await settingsService.syncFolhaCertaClock(params);

      dispatch(success(folhaCertaClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'folhaCertaClock' } }
  function success(folhaCertaClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, folhaCertaClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncSeniorUsers(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const seniorUsers = await settingsService.syncSeniorUsers(params);

      dispatch(success(seniorUsers));
      dispatch(alertActions.success('Sincronização Solicitada. Verifique logs de integração para resultado.'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'seniorUsers' } }
  function success(seniorUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, seniorUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncAccounts(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const syncAccounts = await settingsService.syncAccounts(params);

      dispatch(success(syncAccounts));
      dispatch(alertActions.success('Contas atualizadas'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'accounts' } }
  function success(syncAccounts) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, syncAccounts } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function expireRequests(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const syncAccounts = await settingsService.expireRequests(params);

      dispatch(success(syncAccounts));
      dispatch(alertActions.success('Solicitações Expiradas'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'expireRequests' } }
  function success(syncAccounts) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, syncAccounts } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function removeExpired(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const syncAccounts = await settingsService.removeExpired(params);

      dispatch(success(syncAccounts));
      dispatch(alertActions.success('Contas Expiradas Removidas'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'removeExpired' } }
  function success(syncAccounts) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, syncAccounts } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncAhgoraClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const ahgoraClock = await settingsService.syncAhgoraClock(params);

      dispatch(success(ahgoraClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };
  
  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'ahgoraClock' } }
  function success(ahgoraClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, ahgoraClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncPontoTelClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const pontoTelClock = await settingsService.syncPontoTelClock(params);

      dispatch(success(pontoTelClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };
  
  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'pontoTelClock' } }
  function success(pontoTelClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, pontoTelClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncApDataClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const apDataClock = await settingsService.syncApDataClock(params);

      dispatch(success(apDataClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'apDataClock' } }
  function success(apDataClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, apDataClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncSinergyClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const sinergyClock = await settingsService.syncSinergyClock(params);

      dispatch(success(sinergyClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'sinergyClock' } }
  function success(sinergyClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, sinergyClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncTivitClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const tivitClock = await settingsService.syncTivitClock(params);

      dispatch(success(tivitClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'tivitClock' } }
  function success(ahgoraClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, ahgoraClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncBemClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const bemClock = await settingsService.syncBemClock(params);

      dispatch(success(bemClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'bemClock' } }
  function success(ahgoraClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, ahgoraClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function testForPontoConnection(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const forPontoTest = await settingsService.testForPontoConnection(params);

      dispatch(success(forPontoTest));
      dispatch(alertActions.success('Conexão funcionando'));
    } catch(error) {      
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'forPontoTest' } }
  function success(forPontoTest) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, forPontoTest } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncForPontoClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const forPontoClock = await settingsService.syncForPontoClock(params);

      dispatch(success(forPontoClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'forPontoClock' } }
  function success(forPontoClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, forPontoClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncForPontoUsers(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const forPontoUsers = await settingsService.syncForPontoUsers(params);

      dispatch(success(forPontoUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'forPontoUsers' } }
  function success(forPontoUsers) { return { type: settingsConstants.FORPONTO_SYNC_USERS_SUCCESS, forPontoUsers } }
  function failure(error) { return { type: settingsConstants.FORPONTO_SYNC_USERS_FAILURE, error } }
}

function testDatabaseConnection(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const databaseTest = await settingsService.testDatabaseConnection(params);

      dispatch(success(databaseTest));
      dispatch(alertActions.success('Conexão funcionando'));
    } catch(error) {      
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'databaseTest' } }
  function success(databaseTest) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, databaseTest } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncDatabaseClock(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const databaseClock = await settingsService.syncDatabaseClock(params);

      dispatch(success(databaseClock));
      dispatch(alertActions.success('Registros de ponto importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'databaseClock' } }
  function success(DatabaseClock) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, DatabaseClock } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function syncDatabaseUsers(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const databaseUsers = await settingsService.syncDatabaseUsers(params);

      dispatch(success(databaseUsers));
      dispatch(alertActions.success('Usuários importados'));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'databaseUsers' } }
  function success(databaseUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, databaseUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function testAzureAdAuth() {
  return async dispatch => {
    dispatch(request());

    try {
      const office = await settingsService.testAzureAdAuth();

      dispatch(success(office));
      dispatch(alertActions.success(`Autenticação OK: ${office.id} - ${office.displayName}`));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'azureTest' } }
  function success(forPontoUsers) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, forPontoUsers } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function createAzureAdPolicyAndGroup() {
  return async dispatch => {
    dispatch(request());

    try {
      const policy = await settingsService.createAzureAdPolicyAndGroup();

      dispatch(success(policy));
      dispatch(alertActions.success(policy.message));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'azurePolicy' } }
  function success(policy) { return { type: settingsConstants.ACTION_SYNC_REQUEST, policy } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_REQUEST, error } }
}

function syncAzureAdUsers() {
  return async dispatch => {
    dispatch(request());

    try {
      const policy = await settingsService.syncAzureAdUsers();

      dispatch(success(policy));
      dispatch(alertActions.success(policy.message));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.ACTION_SYNC_REQUEST, sync: 'azureUsers' } }
  function success(policy) { return { type: settingsConstants.ACTION_SYNC_SUCCESS, policy } }
  function failure(error) { return { type: settingsConstants.ACTION_SYNC_FAILURE, error } }
}

function updateLicense(license) {
  return async dispatch => {
    dispatch(request());

    try {
      const response = await settingsService.updateLicense(license);

      if (!response.error) {
        dispatch(success(response));
        dispatch(alertActions.success('Licença Atualizada'));
      } else {
        dispatch(alertActions.error(response.message));
      }
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));      
    }
  };

  function request() { return { type: settingsConstants.LICENSE_UPDATE_REQUEST } }
  function success(forPontoUsers) { return { type: settingsConstants.LICENSE_UPDATE_SUCCESS, forPontoUsers } }
  function failure(error) { return { type: settingsConstants.LICENSE_UPDATE_FAILURE, error } }
}